import HttpRequest from "./http_request";

class LmgProvider extends HttpRequest {

	// Branch
    BranchCreate(data) {
        return this.post("branch", data);
    }
    BranchUpdate(id,data) {
        return this.put("branch/" + id, data);
    }
    BranchList(data) {
        return this.get("branch", data);
    }

    // User
    UserCreate(data) {
        return this.post("user", data);
    }
    UserChangePassword(id, data) {
        return this.put("user/password/" + id, data);
    }
    UserChangePasswordByAdmin(id,data) {
        return this.put("user/password/" + id, data);
    }
    UserSetActive(id,data) {
        return this.put("user/active/" + id, data);
    }
    UserList(data) {
        return this.get("user", data);
    }

    // insurance type
    InsuranceCreate(data) {
        // return this.post("insurance", data);
        return this.post("v2/insurance", data);
    }
    InsuranceUpdate(id,data) {
        // return this.put("insurance/" + id, data);
        return this.put("v2/insurance/" + id, data);
    }

    InsuranceDelete(id,data) {
        // return this.put("insurance/" + id, data);
        return this.delete("v2/insurance/" + id, data);
    }
    InsuranceList(data) {
        return this.get("v2/insurance", data);
    }

    InsuranceListUpper(data){
        return this.get("v2/insurance/upper", data);
    }

    // Insurance Catalog V2 — full active-node tree (level=0).
    // Pass { includeInactive: 1 } to also return is_active=0 rows (Wave-1 backend).
    InsuranceCatalog(data){
        return this.get("v2/insurance/upper", data);
    }

    

    // TType  (ประเภทตัวแทน)
    TTypeCreate(data) {
        return this.post("ttype", data);
    }
    TTypeUpdate(id,data) {
        return this.put("ttype/" + id, data);
    }
    TTypeList(data) {
        return this.get("ttype", data);
    }
    TTypeCodeList(data) {
        return this.get("code", data);
    }

    // Person
    PersonGetImage(data){
        return this.get("v2/person/photo/base64?id=" + data);
    }

    PersonCreate(data) {
        return this.postFormData("v2/person", data);
    }
    PersonUpdate(id,data) {
        return this.putFormData("v2/person/" + id, data);
    }
    PersonUpdateCredit(id,data) {
        return this.put("person/credit/" + id, data);
    }
    PersonList(data) {
        return this.get("v2/person", data);
    }

    PersonDropdownList(data) {
        return this.get("v2/person/dropdown", data);
    }

    PersonListNoLogin(data) {
        return this.get("person/nologin", data);
    }

    

    // Commision Profile
    CommCreate(data) {
        return this.post("comProfile", data);
    }
    CommUpdate(id,data) {
        return this.put("comProfile/" + id, data);
    }
    CommDelete(id) {
        return this.delete("comProfile/" + id);
    }
    CommList(data) {
        return this.get("comProfile", data);
    }

    CommExtraList(data) {
        return this.get("comProfile/extra?comprofileID="+ data);
    }

    CommUpdateExtraDataByPerson(data) {
        return this.post("comProfile/extra/adj", data);
    }

    CommExtraListByPerson(data) {
        return this.get("comProfile/person?personID="+ data);
    }

    CommExtraCreate(data) {
        return this.post("comProfile/extra", data);
    }
    CommExtraDelete(id) {
        return this.delete("comProfile/extra/" + id);
    }



    // Bank
    BankCreate(data) {
        return this.post("bank", data);
    }
    BankUpdate(id,data) {
        return this.put("bank/" + id, data);
    }
    BankDelete(id) {
        return this.delete("bank/" + id);
    }
    BankList(data) {
        return this.get("bank", data);
    }
    BankForPayment() {
        return this.get("bank/for-payment");
    }

    // Transaction
    TransactionCreate(data) {
        return this.postFormData("v4/transaction", data);
    }
    TransactionList(data) {
        return this.get("v4/transaction", data);
    }
	TransactionCancel(data) {
        return this.postJson("v4/transaction/cancel", data);
    }

	TransactionByListID(data){
		return this.postJson("v4/transaction/list", data);
	}

	TransactionCancelList(data) {
        return this.get("v4/transaction/cancel", data);
    }

    TransactionUpdatePolicyNumber(id, data) {
        return this.put("v4/transaction/update/policyNumber/" + id, data);
    }

    TransactionUpdateDate(id, data) {
        return this.put("v4/transaction/update/date/" + id, data);
    }

    // Phase 1 (issue #47): toggle whether the branch has paid the agent's
    // commission back for this sale. data = { paid: 0|1 }.
    TransactionUpdateCommissionPaid(id, data) {
        return this.put("v4/transaction/update/commissionPaid/" + id, data);
    }

    
    TransactionCalCommision(data) {
        return this.get("comProfile/cal", data);
    }

    // Payment
    PaymentCreate(data) {
        return this.postFormData("payment", data);
    }
    PaymentList(data) {
        return this.get("payment", data);
    }
    // โยกเงินสดที่พนักงานรับมา
    PaymentClearCreate(data){
        return this.post("payment/clear", data);
    }
    PaymentClearList(data){
        return this.get("payment/clear", data);
    }
    // เงินสดในสาขา
    PaymentBranchCash(data){
        return this.get("payment/branch/cash", data);
    }
    PaymentBranchTransferCreate(data){
        return this.post("payment/branch/cash/tranfer", data);
    }
    PaymentBranchTransferList(data){
        return this.get("payment/branch/cash/tranfer/log", data);
    }
    PaymentImage(data){
        return this.get_array_buffer("payment/tfimage?id="+ data);
    }
    // Fetch a stored file by name WITH the auth header (the /api/file/image
    // endpoint is JWT-protected, so opening its URL directly in a new tab 401s).
    // Returns a Blob — caller makes an object URL to view/open it.
    FileImage(fileName){
        return this.get_blob("file/image", { FileName: fileName });
    }
    // Multi-attachment viewer (payment_attachment table).
    // List: [{id, filename}] for a payment; Attachment: raw file bytes per attachment id.
    PaymentAttachments(id){
        return this.get("payment/attachments?id=" + id);
    }
    PaymentAttachment(id){
        return this.get_array_buffer("payment/attachment?id=" + id);
    }


    // Billing
    BillingCreate(data) {
        return this.postFormData("billing/payment", data);
    }
    BillingList(data) {
        return this.get("billing", data);
    }

    BillingReportList(data) {
        return this.get("billing/duedate/summary", data);
    }

	// // Invoice
    InvoiceCreate(data) {
        return this.postJson("invoice", data);
    }
	InvoicePaid(data) {
        return this.postFormData("invoice/pay", data);
    }
    InvoiceList(data) {
        return this.get("invoice", data);
    }
	InvoiceBillingList(data) {
        return this.get("billing/choose", data);
    }
	InvoiceReport(data) {
        return this.get_blob("report/invoice", data);
    }
    // ยกเลิกใบวางบิล — identify the invoice by PRIMARY KEY, never by number.
    //
    // billing_invoice.number is NOT unique in production: branch 2 alone has 6
    // duplicated numbers, and "50/05/68" sits on 12 separate rows (ids
    // 3894–3905, all unpaid). A by-number lookup takes the first match, so
    // cancelling any of those 12 always cancelled id 3894 — releasing the wrong
    // invoice's billings silently. The signature takes the id itself so no
    // caller can hand this an InvoiceNumber by mistake.
    //
    // PUT /api/invoice/cancel — the BE reads v.Int(c, "id"), i.e. c.FormValue,
    // which is case-sensitive, so the field must be lowercase `id` and the body
    // must be form-urlencoded (put(), not putJson()). It still accepts
    // `invoice_number` as a legacy fallback, but refuses when that number is
    // ambiguous — we never take that path.
    //
    // NOTE: the wire shape lives here and nowhere else — if the BE renames the
    // field, this one line changes.
    InvoiceCancel(invoiceID) {
        return this.put("invoice/cancel", { id: Number(invoiceID) });
    }
    InvoiceBillings(invoiceID){
        return this.get("invoice/billings?id=" + invoiceID);
    }
    // เพิ่มรายการขายเข้าใบวางบิลเดิม (ใบที่ยังไม่ชำระ / status 1) — วางบิลไปแล้ว
    // แต่มีรายการขายเพิ่มที่ตัวแทนจะโอนมาในสลิปเดียวกัน.
    // PUT /api/invoice/billings — data = { InvoiceID, BillingList:[ids], Note }
    // NOTE: the BE route/verb for this is the only thing that changes if the
    // contract moves — keep the call in this one function.
    InvoiceAddBillings(data){
        return this.putJson("invoice/billings", data);
    }




    // Customer
    CustomerCreate(data) {
        return this.post("v2/customer", data);
    }

    CustomerList(data) {
        return this.get("v2/customer", data);
    }

    CustomerUpdate(id,data) {
        return this.put("v2/customer/" + id, data);
    }

    CustomerCheckID(data) {
        return this.get("v2/customer/id/check", data);
    }

    GetAPIVersion(){
        return this.get("version" );
    }

    ReportDiscount(data){
        return this.get_blob("report/discount",data );
    }

    ReportTaxDiscount(data){
        return this.get_blob("wht/export",data );
    }


	// Address
	AddressProvinces(data) {
        return this.get("cities/province", data);
    }
	AddressDistrict(data) {
        return this.get("cities/district", data);
    }
	AddressSubDistrict(data) {
        return this.get("cities/subdistrict", data);
    }


	WhtList(data){
		return this.get("wht",data);
	}

	WhtExport(data){
		return this.get_blob("wht/export",data);
	}

	WhtCreate(data){
		return this.postJson("wht",data);
	}

	// Finance — manager overview of billings + invoice + cash clearing
	FinanceList(data){
		return this.get("finance", data);
	}
	FinanceSummary(data){
		return this.get("finance/summary", data);
	}

	// Quick Payment — รับชำระที่สาขา (Issue #2)
	QuickPaymentLookup(policy){
		return this.get("quick-payment/lookup", { policy });
	}
	QuickPaymentCreate(data){
		// FormData: BillingList(JSON), PaymentVia, PaymentBankID, PaidDate, Payslip(file)
		return this.postFormData("quick-payment", data);
	}
	QuickPaymentQR(data){
		// { InvoiceID }
		return this.post("quick-payment/qr", data);
	}

	// DMS — ใบนำส่ง (Phase 3): สร้าง/list/detail/delete ชุดนำส่ง + PDF
	DmsPoliciesAvailable(data){
		// list กรมธรรม์ที่ยังไม่อยู่ใน DMS batch อื่น (filter ตาม round ได้)
		return this.get("dms/policies-available", data);
	}
	DmsBatchCreate(data){
		// FormData: batch_number, batch_date, round, month, year, note, Pdf(file), Items(JSON)
		return this.postFormData("dms/batch", data);
	}
	DmsBatchUpdate(id, data){
		// แก้ไขชุดนำส่งเดิม (non-cancelled) — FormData เดียวกับ create; ไม่แนบ Pdf = คงไฟล์เดิม
		return this.putFormData("dms/batch/" + id, data);
	}
	DmsBatchList(data){
		return this.get("dms/batch", data);
	}
	DmsBatchDetail(id){
		return this.get("dms/batch/" + id);
	}
	DmsBatchDelete(id){
		return this.delete("dms/batch/" + id);
	}
	DmsBatchSubmit(id){
		// นำส่ง (draft→submitted) — ตัดยอด ledger; empty body
		return this.put("dms/batch/" + id + "/submit");
	}
	DmsBatchFile(id){
		// PDF/รูปแนบของชุดนำส่ง — mirror PaymentImage (arraybuffer)
		return this.get_array_buffer("dms/batch/file?id=" + id);
	}
	DmsBatchExportPdf(id){
		// export ใบนำส่งเป็น PDF (เอกสารนำส่ง) — blob, filename DMS-<batch_number>.pdf
		return this.get_blob("dms/batch/export/pdf?id=" + id);
	}
	DmsBatchExportXlsx(id){
		// export ใบนำส่งเป็น XLSX (record ดิบ) — blob, filename DMS-<batch_number>.xlsx
		return this.get_blob("dms/batch/export/xlsx?id=" + id);
	}

	// Branch Money — รายงาน pool สาขา (Phase 4): ยอดคงเหลือ + per-policy status
	BranchMoneyBalance(data){
		// ยอด pool ปัจจุบัน แยกตามประเภท/บัญชี + movement ตามช่วงเวลา → Datum
		return this.get("branch-money/balance", data);
	}
	BranchMoneyPolicyStatus(data){
		// per-กรมธรรม์: จ่ายยัง / วิธี / บัญชี / DMS ส่งยัง → Data (list, paginated)
		return this.get("branch-money/policy-status", data);
	}

	// PromptPay account ต่อสาขา
	PromptPayAccountList(data){
		return this.get("promptpay-account", data);
	}
	PromptPayAccountCreate(data){
		return this.post("promptpay-account", data);
	}
	PromptPayAccountUpdate(id, data){
		return this.put("promptpay-account/" + id, data);
	}

}

export default LmgProvider;
